function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3.92004,
  width: 22.08,
  height: 22.08,
  rx: 4,
  stroke: "#0C0030",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.76001 5.83997L8.76001 1.99997",
  stroke: "#0C0030",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.32 5.83997L19.32 1.99997",
  stroke: "#0C0030",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1688 10.2655C13.5514 9.5869 14.5286 9.5869 14.9111 10.2655L15.7959 11.8352C15.9386 12.0884 16.1843 12.2669 16.4692 12.3244L18.2355 12.6808C18.9991 12.8349 19.3011 13.7643 18.7739 14.3378L17.5544 15.6643C17.3577 15.8783 17.2638 16.1672 17.2972 16.4559L17.5041 18.2458C17.5935 19.0197 16.8029 19.5941 16.0945 19.2699L14.4562 18.52C14.1919 18.3991 13.8881 18.3991 13.6238 18.52L11.9854 19.2699C11.2771 19.5941 10.4865 19.0197 10.5759 18.2458L10.7828 16.4559C10.8161 16.1672 10.7222 15.8783 10.5256 15.6643L9.30612 14.3378C8.7789 13.7643 9.08089 12.8349 9.84452 12.6808L11.6107 12.3244C11.8956 12.2669 12.1414 12.0884 12.2841 11.8352L13.1688 10.2655Z",
  fill: "#FFCB7C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1688 10.2655C13.5514 9.5869 14.5286 9.5869 14.9111 10.2655L15.7959 11.8352C15.9386 12.0884 16.1843 12.2669 16.4692 12.3244L18.2355 12.6808C18.9991 12.8349 19.3011 13.7643 18.7739 14.3378L17.5544 15.6643C17.3577 15.8783 17.2638 16.1672 17.2972 16.4559L17.5041 18.2458C17.5935 19.0197 16.8029 19.5941 16.0945 19.2699L14.4562 18.52C14.1919 18.3991 13.8881 18.3991 13.6238 18.52L11.9854 19.2699C11.2771 19.5941 10.4865 19.0197 10.5759 18.2458L10.7828 16.4559C10.8161 16.1672 10.7222 15.8783 10.5256 15.6643L9.30612 14.3378C8.7789 13.7643 9.08089 12.8349 9.84452 12.6808L11.6107 12.3244C11.8956 12.2669 12.1414 12.0884 12.2841 11.8352L13.1688 10.2655Z",
  stroke: "#DCD8E6"
});

var SvgBlackCalendar = function SvgBlackCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/black-calendar.b7a95e2c.svg";
export { ForwardRef as ReactComponent };